// extracted by mini-css-extract-plugin
export default {"root":"Vote_root__IVpnL","header":"Vote_header__u+IeS","count":"Vote_count__du3zk"};